var _g, _g2, _g3, _path, _g4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTree(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 290,
    height: 281,
    viewBox: "0 0 290 281",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1821_15773)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.414 138.321C151.134 138.321 120.914 108.252 120.914 71.1604C120.914 34.0687 151.134 4 188.414 4C225.693 4 255.914 34.0687 255.914 71.1604C255.914 108.252 225.693 138.321 188.414 138.321Z",
    fill: "url(#paint0_linear_1821_15773)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M238.792 26.4556C245.089 41.1096 245.943 57.5139 241.202 72.7369C236.461 87.9599 226.435 101.01 212.914 109.555C199.393 118.099 183.259 121.582 167.395 119.381C151.531 117.179 136.971 109.437 126.316 97.5373C130.163 106.49 135.919 114.503 143.187 121.022C150.456 127.542 159.061 132.411 168.408 135.292C177.756 138.174 187.621 138.999 197.32 137.711C207.02 136.422 216.322 133.051 224.582 127.831C232.842 122.611 239.863 115.667 245.158 107.479C250.452 99.291 253.895 90.0557 255.247 80.4128C256.598 70.7699 255.827 60.9498 252.986 51.633C250.145 42.3161 245.301 33.7253 238.792 26.4556Z",
    fill: "#46504B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.621 175.544L182.985 268.937H191.166L187.075 78.2194H186.859L184.698 171.192L176.241 166.762C176.014 166.636 175.763 166.557 175.505 166.529C175.246 166.5 174.984 166.524 174.735 166.598C174.485 166.672 174.253 166.794 174.052 166.959C173.851 167.123 173.685 167.326 173.564 167.555C173.443 167.784 173.369 168.035 173.346 168.293C173.324 168.551 173.354 168.811 173.434 169.057C173.513 169.304 173.642 169.532 173.812 169.728C173.982 169.924 174.189 170.085 174.422 170.2L184.621 175.544Z",
    fill: "#46504B"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter1_f_1821_15773)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.226 268.979C124.521 257.91 117.436 240.509 96.826 246.088C96.826 212.834 39.3758 210.078 39.3758 245.312C29.3368 235.328 0.638908 245.732 11.2194 268.977C11.2336 269.028 119.226 268.979 119.226 268.979Z",
    fill: "url(#paint1_linear_1821_15773)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter2_f_1821_15773)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.799 268.986C280.297 261.758 275.616 250.394 261.999 254.037C261.999 232.32 224.04 230.521 224.04 253.53C217.408 247.01 198.446 253.804 205.437 268.985C205.446 269.018 276.799 268.986 276.799 268.986Z",
    fill: "url(#paint2_linear_1821_15773)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M185.606 268C188.513 261.116 190.762 252.746 178.758 246.579C176.385 245.518 173.761 245.198 171.213 245.658C168.664 246.119 166.304 247.339 164.424 249.169C164.146 244.671 162.231 240.446 159.061 237.337C157.069 235.257 154.681 233.621 152.048 232.533C149.415 231.444 146.592 230.925 143.755 231.009C134.011 231.518 124.818 239.198 121.2 249.782C116.331 247.772 110.886 247.835 106.062 249.957C101.238 252.079 97.4311 256.087 95.4781 261.098C95.2522 261.676 95.0521 262.265 94.8799 262.864C91.4341 259.277 87.2562 256.524 82.6491 254.805C78.0419 253.085 73.1207 252.441 68.2421 252.921C63.3635 253.4 58.6495 254.991 54.4418 257.577C50.234 260.163 46.6378 263.807 43.9137 268H185.606Z",
    fill: "url(#paint3_linear_1821_15773)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_1821_15773)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.43 238.455C232.265 236.581 230.196 235.509 227.817 236.059C225.438 236.61 223.63 238.561 223.794 240.425C223.959 242.29 226.028 243.372 228.407 242.831C230.786 242.29 232.594 240.319 232.43 238.455Z",
    fill: "url(#paint4_linear_1821_15773)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M222.663 268.999C210.857 268.999 218.969 253.775 217.064 246.221C214.963 245.396 213.083 244.094 211.572 242.417C210.062 240.74 208.962 238.736 208.361 236.561C208.361 236.561 221.812 233.383 227.343 240.029C238.543 251.097 245.801 268.999 222.663 268.999Z",
    fill: "url(#paint5_linear_1821_15773)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.141 238.26C214.772 238.556 214.338 238.607 214.172 238.352C214.006 238.097 214.172 237.659 214.523 237.332C214.873 237.006 215.325 236.985 215.491 237.23C215.657 237.475 215.51 237.954 215.141 238.26Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.818 234.621C219.211 233.365 221.454 233.964 222.837 235.983C224.22 238.001 224.22 240.648 222.837 241.914C221.454 243.179 219.201 242.571 217.818 240.561C216.435 238.552 216.435 235.886 217.818 234.621Z",
    fill: "url(#paint6_linear_1821_15773)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.364 255.041C212.075 256.007 210.238 261.494 213.99 266.169C211.223 266.275 209.005 267.338 209.235 268.404C209.334 268.866 209.898 269 210.371 269H222.209C225.758 269 226.193 264.73 225.11 260.354C224.027 255.978 220.913 254.404 217.364 255.041Z",
    fill: "url(#paint7_linear_1821_15773)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.027 269C229.673 269 244.259 269 258.012 269C258.142 269 258.149 268.822 258.019 268.817C255.004 268.686 250.561 268.508 245.677 268.362C235.379 267.879 231.569 266.594 231.569 266.594L224.027 269Z",
    fill: "url(#paint8_linear_1821_15773)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.244 246.646C215.256 251.428 211.978 252.51 211.852 254.017C211.727 255.524 218.708 250.829 218.708 250.829L218.244 246.646Z",
    fill: "#46504B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.986 239.991H204.938C204.922 239.972 204.914 239.948 204.914 239.924C204.914 239.899 204.922 239.875 204.938 239.856C205.416 239.063 206.077 238.395 206.866 237.909C207.655 237.424 208.549 237.134 209.473 237.064C209.499 237.064 209.523 237.075 209.542 237.093C209.56 237.111 209.57 237.135 209.57 237.161C209.568 237.186 209.557 237.209 209.539 237.227C209.521 237.244 209.498 237.255 209.473 237.258C208.582 237.328 207.72 237.611 206.96 238.081C206.2 238.552 205.563 239.197 205.102 239.962C205.089 239.979 205.07 239.992 205.049 239.997C205.028 240.002 205.006 240 204.986 239.991Z",
    fill: "#46504B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.727 241.256C206.715 241.254 206.702 241.249 206.692 241.242C206.681 241.235 206.672 241.225 206.666 241.214C206.66 241.203 206.656 241.191 206.654 241.178C206.653 241.165 206.655 241.152 206.659 241.14C207.336 237.923 209.348 237.093 209.425 237.064C209.437 237.056 209.45 237.051 209.464 237.048C209.478 237.046 209.492 237.047 209.506 237.051C209.519 237.055 209.532 237.062 209.543 237.071C209.553 237.08 209.562 237.092 209.567 237.105C209.573 237.118 209.576 237.131 209.576 237.146C209.575 237.16 209.572 237.174 209.566 237.186C209.56 237.199 209.551 237.21 209.54 237.219C209.529 237.228 209.516 237.234 209.502 237.238C209.502 237.238 207.501 238.068 206.843 241.179C206.841 241.192 206.836 241.204 206.829 241.215C206.822 241.226 206.813 241.235 206.802 241.242C206.791 241.249 206.779 241.254 206.766 241.257C206.753 241.259 206.74 241.259 206.727 241.256Z",
    fill: "#46504B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.205 221.035L226.26 219.364L226.424 218.968C226.656 218.404 226.983 217.885 227.391 217.432C227.721 217.076 228.115 216.785 228.551 216.572C229.464 216.189 230.4 215.866 231.356 215.606C232.11 215.384 232.574 215.085 232.729 214.708C232.802 214.545 232.84 214.369 232.84 214.191C232.84 214.013 232.802 213.837 232.729 213.674C232.542 213.317 232.223 213.046 231.839 212.921C231.614 212.825 231.373 212.776 231.128 212.776C230.884 212.776 230.642 212.825 230.418 212.921C229.825 213.247 229.354 213.755 229.073 214.37L225.254 212.167C225.9 210.845 227.017 209.811 228.387 209.269C230.018 208.787 231.772 208.957 233.28 209.743C234.592 210.228 235.727 211.096 236.539 212.235C236.972 212.836 237.241 213.54 237.319 214.277C237.397 215.014 237.281 215.758 236.983 216.437C236.724 217.036 236.306 217.554 235.775 217.934C234.897 218.474 233.937 218.866 232.932 219.093C232.246 219.234 231.591 219.495 230.998 219.866C230.646 220.189 230.375 220.589 230.205 221.035ZM225.679 220.359L229.905 222.146L228.329 225.875L224.103 224.078L225.679 220.359Z",
    fill: "#FF6E6E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1821_15773",
    x: 116.914,
    y: 0,
    width: 143,
    height: 272.938,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_1821_15773"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1821_15773",
    x: 0.913696,
    y: 212,
    width: 128,
    height: 65,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_1821_15773"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1821_15773",
    x: 191.914,
    y: 225,
    width: 98,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "effect1_foregroundBlur_1821_15773"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_1821_15773",
    x: 223.284,
    y: 235.415,
    width: 9.65588,
    height: 8.05542,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_1821_15773"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1821_15773",
    x1: 255.914,
    y1: 209.875,
    x2: 145.696,
    y2: -0.281696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#9AE0C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.513542,
    stopColor: "#5EC990"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6DE8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1821_15773",
    x1: 120.914,
    y1: 295.103,
    x2: 99.5096,
    y2: 202.287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#9AE0C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.513542,
    stopColor: "#5EC990"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6DE8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1821_15773",
    x1: 277.914,
    y1: 286.047,
    x2: 264.081,
    y2: 225.362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#9AE0C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.513542,
    stopColor: "#5EC990"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6DE8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1821_15773",
    x1: 187.914,
    y1: 287.71,
    x2: 173.725,
    y2: 216.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#9AE0C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.513542,
    stopColor: "#5EC990"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6DE8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1821_15773",
    x1: 226.708,
    y1: 240.683,
    x2: 232.31,
    y2: 227.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46504B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1821_15773",
    x1: 221.306,
    y1: 262.33,
    x2: 240.815,
    y2: 205.318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#323835"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1821_15773",
    x1: 219.177,
    y1: 239.783,
    x2: 227.808,
    y2: 223.402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46504B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1821_15773",
    x1: 219.415,
    y1: 266.109,
    x2: 215.77,
    y2: 250.056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A433E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D7370"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1821_15773",
    x1: 232.949,
    y1: 269.42,
    x2: 235.125,
    y2: 259.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46504B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTree);
export default __webpack_public_path__ + "static/media/Tree.ad2840f0d4412f748f9c080e0209cc97.svg";
export { ForwardRef as ReactComponent };